const en_cochesnet = {
  POWERED_BY: "Powered by",
};

export default en_cochesnet;
